import { privateAPI, publicAPI } from '@api/core'
import { UserService } from '@api/service/userService'
import { throwError } from '@api/utils/throwError'

export const userDataRemote = (): UserService => ({
  tokenToUser: async (token) => {
    const headers = {
      Authorization: `Bearer ${token}`,
    }
    try {
      const response = await publicAPI.get({
        headers,
        url: `/user`,
      })
      return response.data
    } catch (error) {
      throwError(error)
    }
  },
  login: async (username, password) => {
    try {
      const response = await publicAPI.post({
        url: `/auth/authorize`,
        data: { username, password },
      })
      return response.data
    } catch (error) {
      throwError(error)
    }
  },
  validateToken: async () => {
    try {
      const response = await privateAPI.get({
        url: `/user`,
      })
      return response.data
    } catch (error) {
      return false
    }
  },
  checkNickname: async (nickname) => {
    try {
      const response = await publicAPI.get({
        url: `/user/check/nickname`,
        params: { nickname },
      })
      return response.data
    } catch (error) {
      //error.response.status = 500
      return throwError(error)
    }
  },
  signup: async (signupDTO) => {
    try {
      const response = await publicAPI.post({
        url: `/user`,
        data: { ...signupDTO },
      })
      return response.data
    } catch (error) {
      return throwError(error)
    }
  },
  sendEmailOTP: async (email) => {
    try {
      const response = await publicAPI.post({
        url: `/verification/email`,
        data: { email },
      })
      return response.data
    } catch (error) {
      return throwError(error)
    }
  },
  verificationEmailOTP: async (id, code) => {
    try {
      const response = await publicAPI.post({
        url: `/verification/email/register`,
        data: { id, code },
      })
      return response.data
    } catch (error) {
      return throwError(error)
    }
  },
  findId: async (name, email) => {
    try {
      const response = await publicAPI.get({
        url: `/user/find/username`,
        params: { name, email },
      })
      return response.data
    } catch (error) {
      return throwError(error)
    }
  },
  findPassword: async (username, name, email) => {
    try {
      const response = await publicAPI.post({
        url: `/user/find/password`,
        data: { username, name, email },
      })
      return response.data
    } catch (error) {
      return throwError(error)
    }
  },
})
